import { useMutation, useQueryClient } from "@tanstack/react-query";
import { adminApi } from "../api/adminApi";

export function useSetFeedbackDoneMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, done }) => adminApi.setFeedbackDone(id, done),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["admin", "feedbacks"] }),
  });
}
